angular.module('impactx.legallinking', []);